import styles from './Section109Guard.module.css';

/**
 * 변호사법 §109 회피 — 챗봇 상단 고정 멘트 (기획 02 §3.3).
 * 응답 카드 본문에 면책 문구를 강제 삽입하지 않는 대신 이 영역으로 분리.
 */
export function Section109Guard() {
  return (
    <div className={styles.guard} role="note" aria-label="법적 고지">
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
        className={styles.icon}
      >
        <path
          d="M8 1.5L14.5 13H1.5L8 1.5z"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinejoin="round"
        />
        <path d="M8 6v3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        <circle cx="8" cy="11.4" r="0.7" fill="currentColor" />
      </svg>
      <span>
        본 챗봇의 응답은 <strong>일반 법률 정보</strong>이며 특정 사건에 대한 자문이 아닙니다.
        정확한 검토는 변호사 상담을 받으세요.
      </span>
    </div>
  );
}
